<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="슈퍼바이저 조회"
      desc="슈퍼바이저들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="flex-align space-between" style="margin:12px 0">
      <button @click="openDeleteSuperVisorModal"
              class="button is-primary">선택 삭제
      </button>
      <button @click="$router.push('supervisor/create')"
              class="button is-primary">슈퍼바이저 등록
      </button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="700"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="name" slot-scope="props">
        <span class="unselect" style="text-decoration: underline" @click="detailLink(props.item.id)">{{ props.item.name }}</span>
      </div>
    </admin-table>

    <modal name="deleteSuperVisorModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="삭제" :useTab="false">
          <div>선택하신 {{ getIdList().length }}개의 슈퍼바이저를 삭제하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('deleteSuperVisorModal')">취소</button>
            <button class="button is-primary" @click="deleteSuperVisor">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: 'SuperPartnerList',
    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    props: ['page'],
    data() {
      return {
        user_id: 0
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('supervisor', 'supervisor');
      },
      getDataFromServer() {
        this.getData();
      },
      detailLink(id) {
        this.$router.push(this.getPath(`supervisor/create?id=${id}`))
      },
      clickItem(item, types) {
        // 수정
        if (types === 'update') {
          this.$router.push(this.getPath('supervisor/create?id=' + item.id));
        }
        // 삭제
        else if (types === 'delete') {

          let value = {
            id: item.id,
            url: 'supervisor/',
            title: '슈퍼바이저를 탈퇴시키겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      // 체크박스 선택 관련 - 일괄 선택시 선택한 id list를 조합함
      getIdList() {
        let id_list = [];
        for (let i = 0; i < this.showcaseCheckArr.length; i++) {
          for (let j = 0; j < this.tableItems.length; j++) {
            if (this.showcaseCheckArr[i].value && this.showcaseCheckArr[i].id === this.tableItems[j].id) {
              id_list.push(this.tableItems[j].id);
            }
          }
        }
        return id_list;
      },
      openDeleteSuperVisorModal() {
        let id_list = this.getIdList();
        if (id_list.length === 0) {
          this.toast('삭제할 슈퍼바이저를 선택해주세요.');
          return;
        }
        this.$modal.show('deleteSuperVisorModal')
      },
      deleteSuperVisor() {
        let id_list = this.getIdList();
        this.$axios.delete(this.getUrl('supervisor/delete/multiple'), {
          data: {
            supervisors: id_list
          }
        }).then(res => {
          if (res.status === 200) {
            this.toast('선택한 슈퍼바이저가 삭제되었습니다.');
            this.$modal.hide('deleteSuperVisorModal');
            this.getData();
            //this.getProduct();
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
